import { ActionType } from '../constants/ActionTypes';
import { Constants } from '../constants/Constants';
import { RestPath } from '../constants/SitePaths'
import config from '../constants/Configs';
import axios from 'axios';
import { message } from "antd";

// Get withdraw
export const getWithdrawBegin = () => ({
    type: ActionType.GET_WITHDRAW_BEGIN
});

export const getWithdrawSuccess = (data) => ({
    type: ActionType.GET_WITHDRAW_SUCCESS,
    payload: data
});

export const getWithdrawError = (data) => ({
    type: ActionType.GET_WITHDRAW_FAILURE,
    payload: data
});

// Get withdraw Details
export const getWithdrawDetailsBegin = () => ({
    type: ActionType.GET_WITHDRAW_DETAILS_BEGIN
});

export const getWithdrawDetailsSuccess = (data) => ({
    type: ActionType.GET_WITHDRAW_DETAILS_SUCCESS,
    payload: data
});

export const getWithdrawDetailsError = (data) => ({
    type: ActionType.GET_WITHDRAW_DETAILS_FAILURE,
    payload: data
});


// Update Withdraw
export const updateWithdrawBegin = () => ({
    type: ActionType.UPDATE_WITHDRAW_BEGIN
});

export const updateWithdrawSuccess = withdraw => ({
    type: ActionType.UPDATE_WITHDRAW_SUCCESS,
    payload: { withdraw }
});

export const updateWithdrawError = (error) => ({
    type: ActionType.UPDATE_WITHDRAW_FAILURE,
    payload: { error }
});


// Get sub affiliates withdraw
export const getSubWithdrawBegin = () => ({
    type: ActionType.GET_SUB_WITHDRAW_BEGIN
});

export const getSubWithdrawSuccess = (data) => ({
    type: ActionType.GET_SUB_WITHDRAW_SUCCESS,
    payload: data
});

export const getSubWithdrawError = (data) => ({
    type: ActionType.GET_SUB_WITHDRAW_FAILURE,
    payload: data
});

// Create withdraw
export const createWithdrawBegin = () => ({
    type: ActionType.CREATE_WITHDRAW_BEGIN
});

export const createWithdrawSuccess = (data) => ({
    type: ActionType.CREATE_WITHDRAW_SUCCESS,
    payload: data
});

export const createWithdrawError = (data) => ({
    type: ActionType.CREATE_WITHDRAW_FAILURE,
    payload: data
});


// Create advanceWithdraw
export const createAdvanceWithdrawBegin = () => ({
    type: ActionType.CREATE_ADVANCE_WITHDRAW_BEGIN
});

export const createAdvanceWithdrawSuccess = (data) => ({
    type: ActionType.CREATE_ADVANCE_WITHDRAW_SUCCESS,
    payload: data
});

export const createAdvanceWithdrawError = (data) => ({
    type: ActionType.CREATE_ADVANCE_WITHDRAW_FAILURE,
    payload: data
});

// get Withdraw Types
export const getWithdrawTypesSuccess = (data) => ({
    type: ActionType.GET_WITHDRAWAL_TYPES_SUCCESS,
    payload: data
});

export const getWithdrawableBalanceSuccess = (data) => ({
    type: ActionType.GET_WITHDRAWABLE_BALANCE_SUCCESS,
    payload: data
});


// get affiliate withdraw
export function getWithdraw(mainPartnerId, affiliateId, pageNumber, filterData) {
    return dispatch => {
        dispatch(getWithdrawBegin());

        let params = filterData ? {
            ...filterData,
            mainPartnerId,
            affiliateId,
            pageNumber
        } : {
                mainPartnerId,
                affiliateId,
                pageNumber
            };

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_WITHDRAW,
            params: params

        }).then((response) => {
            dispatch(getWithdrawSuccess(response.data));
            return response.data;
        })
            .catch((error) => {
                dispatch(getWithdrawError(error));
            });
    }
}


// get  withdraw details
export function getWithdrawDetails(Id) {
    return dispatch => {
        dispatch(getWithdrawDetailsBegin());

        let params = { Id };

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_WITHDRAW_DETAILS,
            params: params

        }).then((response) => {
            dispatch(getWithdrawDetailsSuccess(response.data));
            return response.data;
        })
            .catch((error) => {
                dispatch(getWithdrawDetailsError(error));
            });
    }
}


//Update Affiliate Withdraw
export function updateWithdraw(data, intl) {
    return dispatch => {
        dispatch(updateWithdrawBegin());

        const params = data;

        return axios({
            method: Constants.PUT,
            url: config.BASE_URL + RestPath.UPDATE_WITHDRAW,
            data: JSON.stringify(params),

        }).then((response) => {
            // Success
            dispatch(updateWithdrawSuccess(params));
            message.success(intl.messages.withdraw_changed);

            return response.data;
        })
            .catch((error) => {
                dispatch(updateWithdrawError(error));
                return("error")
            });
    }
}

// get sub affiliate withdraw
export function getSubWithdraw(affiliateId, pageNumber, filterData) {
    return dispatch => {
        dispatch(getSubWithdrawBegin());

        let params = filterData ? {
            ...filterData,
            affiliateId,
            pageNumber
        } : {
                affiliateId,
                pageNumber
            };

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_SUB_WITHDRAW,
            params: params

        }).then((response) => {
            dispatch(getSubWithdrawSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(getSubWithdrawError(error));
            });
    }
}

// create sub affiliate withdraw
export function createWithdraw(affiliateId, filterData) {
    return dispatch => {
        dispatch(createWithdrawBegin());
        let params = {
            AccountNumber: filterData.account_number,
            Amount: filterData.amount,
            BankName: filterData.bank_name,
            CardNumber: filterData.card_number,
            Name: filterData.name,
            ShebaNumber: filterData.sheba_number,
            // ...filterData,
            AffiliateId: affiliateId,
        }

        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.CREATE_WITHDRAW,
            data: params

        }).then((response) => {
            dispatch(createWithdrawSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(createWithdrawError(error));
                return("error")
            });
    }
}

// create advance withdraw
export function createAdvanceWithdraw(advanceWithdrawData, intl) {
    return dispatch => {
        dispatch(createAdvanceWithdrawBegin());
        let params = {
            AffiliateId: advanceWithdrawData.affiliateId,
            Amount: advanceWithdrawData.amount
        };

        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.CREATE_ADVANCE_WITHDRAW,
            data: params

        }).then((response) => {
            dispatch(createAdvanceWithdrawSuccess(response.data));
            message.success(intl.messages.success_withdraw);
            return response.data;
        })
            .catch((error) => {
                dispatch(createAdvanceWithdrawError(error));
                return("error")
            });
    }
}


//get withdraw types
export function getWithdrawTypes() {
    return dispatch => {

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_WITHDRAWAL_TYPES,

        }).then((response) => {
            dispatch(getWithdrawTypesSuccess(response.data));
            return response.data;
        });
    }
}

// get Withdrawable Balance

export function getWithdrawableBalance(affiliateId) {
    return dispatch => {
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_WITHDRAWABLE_BALANCE + '?affId=' + affiliateId

        }).then((response) => {
            dispatch(getWithdrawableBalanceSuccess(response.data));
            return response.data;
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/WithdrawAction.js